Ext.define('SA.view.ProjectSettingsHeader', {
    alias: 'widget.project-settings-header',
    extend: 'Ext.Component',

    cls: 'sa-project-settings-header',

    html: [
        '<div class="sa-project-settings-header-title">Project Settings</div>',
        '<nav class="sa-project-settings-header-nav">',
            '<a data-section="generalSettings" class="sa-project-settings-header-link sa-project-settings-header-link-selected">',
                'General Settings',
            '</a>',
            '<a data-section="manageViews" class="sa-project-settings-header-link">',
                'Manage Views',
            '</a>',
            '<a data-section="removeBuildingBlocks" class="sa-project-settings-header-link">',
                'Remove Locations, Data, or Businesses',
            '</a>',
        '</nav>'
    ],

    initEvents() {
        this.callParent();

        this.el.on('click', this.onLinkClick, this, {delegate: 'a'});
    },

    onLinkClick(ev, clickedLink) {
        for (let link of this.el.dom.querySelectorAll('a')) {
            link.classList.toggle('sa-project-settings-header-link-selected', link === clickedLink);
        }

        this.fireEvent('click:sectionLink', clickedLink.dataset.section);
    }
});